<template>
  <span
    class="gradient-text"
    :style="{
      backgroundImage: 'linear-gradient(to right, ' + colors.join(', ') + ')',
      animationDuration: animationSpeed + 's',
      backgroundSize: '300% 100%',
      backgroundClip: 'text',
      WebkitBackgroundClip: 'text'
    }"
  >
    <slot>{{ text }}</slot>
  </span>
</template>

<script>
export default {
  name: 'GradientText',
  props: {
    text: { type: String, default: '' },
    colors: {
      type: Array,
      default: () => ['#16a34a', '#15803d', '#38bdf8', '#16a34a']
    },
    animationSpeed: { type: Number, default: 8 }
  }
}
</script>

<style scoped>
.gradient-text {
  color: transparent;
  display: inline-block;
  animation: gradient-slide linear infinite;
}

@keyframes gradient-slide {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}
</style>
